import Table from "../../../../../shared/components/Table";
import MonthPicker from "../../../../../shared/components/MonthPicker";
import BankingBalanceCard from "../components/BankingBalanceCard";
// import UnlockBankingCard from "../components/UnlockBankingCard";
import { historyBankingTransactionTableColumns } from "../constants/banking.constant";
import type { IBankingTransactionHistory } from "../interfaces/banking.interface";
import { useFiatTransactions } from "@/features/admin/services/fiat";
import { useState } from "react";

export default function Banking() {
  const currentDate = new Date();
  const selectedMonth = currentDate.getMonth() + 1;
  const selectedYear = currentDate.getFullYear();
  const [filters, setFilters] = useState({
    month: selectedMonth,
    year: selectedYear,
  });

  const { data: transactions = [] } = useFiatTransactions(filters);

  return (
    <div className="flex gap-6">
      <div className="flex-1 min-w-xs flex flex-col gap-6">
        <BankingBalanceCard />
        {/* <UnlockBankingCard /> */}
      </div>
      <div className="flex-2 flex flex-col gap-6">
        <Table<IBankingTransactionHistory>
          title="Transactions"
          headles
          data={transactions}
          columns={historyBankingTransactionTableColumns}>
          <MonthPicker
            value={filters}
            onChange={(value) => setFilters(value)}
          />
        </Table>
      </div>
    </div>
  );
}
